import styled, { css } from 'styled-components'

export const AccordionHeader = styled.div`
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  gap: 170px;
  width: 100%;
  height: 40px;
  align-items: center;
  cursor: pointer;
  border: 1px solid #e6e8eb;
  border-radius: 3px 3px 0px 0px;
`

export const ItemCounter = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 7px;
    background-color: ${theme.primaryColor};
    border-radius: 9px;
    font-style: normal;
    font-weight: 700;
    font-size: 10px;
    color: ${theme.secondaryFontColor};
    margin-left: 4px;
    line-height: 1;
  `}
`

export const TableData = styled.td`
  background-color: #fff;
  width: ${props => props.width || 'auto'};
  border-width: 1px 0px 0px 1px;
  border-style: solid;
  border-color: #e5eaeb;
  padding: 8.5px 8.5px 8.5px 16px;

  &.delete-column {
    background-color: transparent;
    border-width: 0px 0px 0px 1px;
    padding: 0 0 0 10px;
  }

  &&& {
    .icon {
      color: #b5b9c4;
    }
  }
`

export const TableRow = styled.tr`
  width: 100%;

  :last-child {
    ${TableData} {
      border-bottom: 1px solid #e5eaeb;

      &.delete-column {
        border-bottom: none;
      }
    }
  }
`

export const Sign = styled.div`
  padding-right: 4px;
`

export const TableWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
    background-color: ${theme.colors.backgroundColor};
    /* Backgrounds/Gray */
    border-width: 0px 1px 1px 1px;
    border-style: solid;
    border-color: #e5eaeb;
    padding: 16px;
    border-radius: 0px 0px 3px 3px;
    transition: all 400ms ease;
    overflow: hidden;
  `}
`

export const Table = styled.table`
  width: 100%;
  border-radius: 3px;
  border-collapse: collapse;

  &.no-delete {
    border-right: 1px solid #e5eaeb;
  }
`

export const TableDataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
